// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports

// Actions Imports

// Internal Imports
import { ASSET } from "../../../../constants";
import { GlobalUtils } from "../../../../utils";

// Destructuring
const { ASSET_PAGE_URL, ASSET_ITEM_TYPES } = ASSET;
const { truncateString } = GlobalUtils;

class AssetFolder extends Component {
  state = {};

  _navigateToAssetItem = () => {
    const {
      folder: {
        id: folderId,
        name: folderName,
        opportunity_id: opportunityId,
        opportunity_root: opportunityRoot,
        type,
        doc_no: docNo,
      },
      history,
    } = this.props;
    // Check, If the current item is a "Folder" or Not
    let isFolder = false;
    if (type === ASSET_ITEM_TYPES.FOLDER) {
      isFolder = true;
    }
    let url = null;
    if (isFolder) {
      url = `/${ASSET_PAGE_URL}/${folderName
        .toLocaleLowerCase()
        .split(" ")
        .join("-")}/${folderId}`;

      if (opportunityRoot && opportunityId) {
        url = `${url}?opp_id=${opportunityId}`;
      }
    } else {
      url = `/documents/${docNo}`;
    }
    if (url) {
      history.push(encodeURI(encodeURI(url)));
    }
  };

  render() {
    const {
      folder: { id: folderId, name: folderName, isCRMFolder },
      selectedFolderId,
      // isFolderOpen,
    } = this.props;

    // Decide the Current Selected Folder
    let isActiveFolder = false;
    if (selectedFolderId && selectedFolderId === folderId) {
      isActiveFolder = true;
    }
    // Decide the Folder icon
    const folderIcon = "folder";
    let folderIconType = "fal";
    if (isActiveFolder) {
      folderIconType = "fas";
    }
    return (
      <div
        className="assetfolder-container"
        onClick={this._navigateToAssetItem}
        onKeyPress={() => {}}
        tabIndex="0"
        role="button">
        <div
          className={`assetfolder-row ${
            isActiveFolder ? "active-folder" : ""
          }`}>
          <div className="assetfolder-col folder-icon">
            {isCRMFolder ? (
              <span>
                <FontAwesomeIcon
                  icon={[`${folderIconType}`, `${folderIcon}`]}
                  className="crm-folder-icon show-hover"
                />
                <FontAwesomeIcon
                  icon={["fas", `${folderIcon}`]}
                  className="crm-folder-icon hide-hover"
                />
                <FontAwesomeIcon
                  icon={["far", "link"]}
                  className="folder-link-icon"
                />
              </span>
            ) : (
              <span>
                <FontAwesomeIcon
                  icon={[`${folderIconType}`, `${folderIcon}`]}
                  className="show-hover"
                />
                <FontAwesomeIcon
                  icon={["fas", `${folderIcon}`]}
                  className="hide-hover"
                />
              </span>
            )}
          </div>
          <div className="assetfolder-col folder-name">
            <div>
              {folderName ? truncateString(folderName, 23, true) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AssetFolder;



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetLeftSection/AssetFolder/index.js